export const SET_AUTH = 'SET_AUTH';

function setAuth(auth) {
    return {
        type: SET_AUTH,
        auth,
    };
}

export default setAuth;
